import { _ } from "../../../../core/polyglot/polyglot.js";
import { formatAsMonthAndYear } from "../../../../core/helpers/date-formatting-util.js";
import AccountingDocumentWidget from "../../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import ReportViewerWidget from "../../../reports2/ReportViewerWidget/ReportViewerWidget.js";

/**
 * Widget rendering the Comparison tool, which takes the form of
 * a report, that can be edited lively by modifying the report's template
 * and performs the interpretation and calculation on-the-fly. This logic is
 * delegated to the {@link ComparisonToolDocumentService}.
 */
export default class ComparisonToolDocumentContent extends AccountingDocumentWidget {
	renderContentOn(html) {
		return html.div(
			{
				class: "ComparisonToolDocumentContent",
				"data-test": "comparison-tool",
			},
			html.div({ class: "section" }, (html) =>
				html.render(this._makeTable()),
			),
		);
	}

	_makeTable() {
		const report = this._documentState.getReport();

		return new ReportViewerWidget({
			budgetNameRenderer: this._budgetNameRenderer.bind(this),
			estimateNameRenderer: this._estimateNameRenderer.bind(this),
			report,
		});
	}

	_budgetNameRenderer() {
		return _("Budget");
	}

	_estimateNameRenderer({ forecastEstimateId }) {
		const forecastEstimate =
			this._documentState.getForecastEstimateById(forecastEstimateId);
		const forecastEstimatePeriod = forecastEstimate.getCurrentPeriod();
		const monthPeriod = forecastEstimatePeriod.asPeriod();
		const period = monthPeriod.getStart();

		return (html) =>
			html.span(
				_("Estimated from {period}", {
					period: formatAsMonthAndYear(period),
				}),
			);
	}
}
